import { all, call, put, takeLatest } from 'redux-saga/effects'

import BatchPaymentsActionTypes from 'redux/batchPayments/batchPayments-types'
import CardsActionTypes from 'redux/cards/cards-types'
import UserActionTypes from 'redux/user/user-types'

import LedgerActionTypes from '../ledger/ledger-types'
import SettingsActionTypes from '../settings/settings-types'
import TradingDeskActionTypes from '../tradingDeskV2/tradingDeskV2-types'
import TransactionsActionTypes from '../transactions/transactions-types'

import { startToastDisplay } from './toast-actions'

function* cardTopUp({ payload: { cardNumber, type } }) {
    const definition = type === 'Virtual' ? 'virtualCardTopUp' : 'physicalCardTopUp'

    yield put(startToastDisplay({ display: true, toastDefinition: definition, data: cardNumber }))
}
export function* onSuccessCardTopUp() {
    yield takeLatest(CardsActionTypes.SUCCESS_CARD_TOP_UP, cardTopUp)
}

function* cardWithdraw({ payload: { cardNumber, type } }) {
    const definition = type === 'Virtual' ? 'virtualCardWithdraw' : 'physicalCardWithdraw'

    yield put(startToastDisplay({ display: true, toastDefinition: definition, data: cardNumber }))
}
export function* onSuccessCardWithdraw() {
    yield takeLatest(CardsActionTypes.SUCCESS_CARD_WITHDRAW, cardWithdraw)
}

function* successLedgerTopUpWithBankTransfer() {
    yield put(startToastDisplay({ display: true, toastDefinition: 'ledgerTopUpWithBankTransfer', data: '' }))
}
export function* onSuccessLedgerTopUpWithBankTransfer() {
    yield takeLatest(LedgerActionTypes.SUCCESS_TOP_UP_WITH_BANK_TRANSFER, successLedgerTopUpWithBankTransfer)
}

function* successTransfer() {
    yield put(startToastDisplay({ display: true, toastDefinition: 'transferToLedger', data: '' }))
}
export function* onSuccessTransfer() {
    yield takeLatest(LedgerActionTypes.SUCCESS_TRANSFER, successTransfer)
}

function* successTransferToBank() {
    yield put(startToastDisplay({ display: true, toastDefinition: 'transferToBank', data: '' }))
}
export function* onSuccessTransferToBank() {
    yield takeLatest(LedgerActionTypes.SUCCESS_TRANSFER_TO_BANK, successTransferToBank)
}

function* startTopUpTradingDesks({
    payload: {
        data: { sourceCurrencyCode, amount },
    },
}) {
    yield put(startToastDisplay({ display: true, toastDefinition: 'depositTradingDesk', data: `${amount} ${sourceCurrencyCode}` }))
}
export function* onStartTopUpTradingDesks() {
    yield takeLatest(TradingDeskActionTypes.SUCCESS_ACCOUNT_DEPOSIT, startTopUpTradingDesks)
}

function* startWithdrawFromTradingDesk({
    payload: {
        data: { sourceCurrencyCode, amount },
    },
}) {
    yield put(startToastDisplay({ display: true, toastDefinition: 'withdrawTradingDesk', data: `${amount} ${sourceCurrencyCode}` }))
}
export function* onStartWithdrawFromTradingDesk() {
    yield takeLatest(TradingDeskActionTypes.SUCCESS_ACCOUNT_WITHDRAW, startWithdrawFromTradingDesk)
}

function* successExchangeTradingDesk() {
    yield put(startToastDisplay({ display: true, toastDefinition: 'exchangeTradingDesk', data: '' }))
}
export function* onSuccessExchangeTradingDesk() {
    yield takeLatest(TradingDeskActionTypes.SUCCESS_EXCHANGE, successExchangeTradingDesk)
}

function* successCardFreeze() {
    yield put(startToastDisplay({ display: true, toastDefinition: 'cardFreeze', data: '' }))
}
export function* onSuccessCardFreeze() {
    yield takeLatest(CardsActionTypes.SUCCESS_CARD_FREEZE, successCardFreeze)
}

function* successCardUnreeze() {
    yield put(startToastDisplay({ display: true, toastDefinition: 'cardUnfreeze', data: '' }))
}
export function* onSuccessCardInfreeze() {
    yield takeLatest(CardsActionTypes.SUCCESS_CARD_UNFREEZE, successCardUnreeze)
}

function* successCardDeactive() {
    yield put(startToastDisplay({ display: true, toastDefinition: 'cardDeactive', data: '' }))
}
export function* onSuccessCardDeactive() {
    yield takeLatest(CardsActionTypes.SUCCESS_CARD_DEACTIVATE, successCardDeactive)
}

function* failureArchiveSupportConversations({ payload: data }) {
    yield put(startToastDisplay({ display: true, toastDefinition: 'archiveSupportConversations', data: data?.errorMessage[0]?.errorCode }))
}
export function* onFailureArchiveSupportConversations() {
    yield takeLatest(SettingsActionTypes.FAILURE_ARCHIVE_SUPPORT_CONVERSATIONS, failureArchiveSupportConversations)
}

function* failureGetSupportConversations({ payload: data }) {
    yield put(startToastDisplay({ display: true, toastDefinition: 'getSupportConversations', data: data?.errorMessage[0]?.errorCode }))
}
export function* onFailureGetSupportConversations() {
    yield takeLatest(SettingsActionTypes.FAILURE_SUPPORT_CONVERSATIONS, failureGetSupportConversations)
}

function* failureReplySupportConversations({ payload: data }) {
    yield put(
        startToastDisplay({ display: true, toastDefinition: 'failureReplySupportConversations', data: data?.errorMessage[0]?.errorCode })
    )
}
export function* onFailureReplySupportConversations() {
    yield takeLatest(SettingsActionTypes.FAILURE_REPLY_SUPPORT_CONVERSATIONS, failureReplySupportConversations)
}

function* getFailureSupportConversationsDetails({ payload: data }) {
    yield put(
        startToastDisplay({ display: true, toastDefinition: 'failureSupportConversationsDetails', data: data?.errorMessage[0]?.errorCode })
    )
}
export function* onFailureSupportConversationsDetails() {
    yield takeLatest(SettingsActionTypes.FAILURE_SUPPORT_CONVERSATION_DETAILS, getFailureSupportConversationsDetails)
}

function* getFailureGetFile({ payload: data }) {
    yield put(startToastDisplay({ display: true, toastDefinition: 'failureGetFile', data: data?.errorMessage[0]?.errorCode }))
}
export function* onFailureGetFile() {
    yield takeLatest([SettingsActionTypes.FAILURE_GET_FILE, SettingsActionTypes.FAILURE_SUPPORT_CONVERSATION_FILE], getFailureGetFile)
}

function* failureTransactionsView({ payload: data }) {
    yield put(startToastDisplay({ display: true, toastDefinition: 'transactionsView', data: data?.errorMessage[0]?.errorCode }))
}
export function* onFailureTransactions() {
    yield takeLatest(TransactionsActionTypes.ERROR_FILTERING_TRANSACTIONS, failureTransactionsView)
}

function* successArchiveSupportConversations() {
    yield put(startToastDisplay({ display: true, toastDefinition: 'successArchiveSupportConversations', data: '' }))
}
export function* onSuccessArchiveSupportConversations() {
    yield takeLatest(SettingsActionTypes.SUCCESS_ARCHIVE_SUPPORT_CONVERSATIONS, successArchiveSupportConversations)
}

function* successReplySupportConversations() {
    yield put(startToastDisplay({ display: true, toastDefinition: 'successReplySupportConversations', data: '' }))
}
export function* onSuccessReplySupportConversations() {
    yield takeLatest(SettingsActionTypes.SUCCESS_REPLY_SUPPORT_CONVERSATIONS, successReplySupportConversations)
}

function* failureBatchPaymentsView({ payload: data }) {
    yield put(startToastDisplay({ display: true, toastDefinition: 'batchPaymentsView', data: data?.errorMessage[0]?.errorCode }))
}
export function* onFailureBatchPayments() {
    yield takeLatest(BatchPaymentsActionTypes.FAILURE_GET_IMPORTED_BATCH_PAYMENTS, failureBatchPaymentsView)
}

function* successSignOutDevice() {
    yield put(startToastDisplay({ display: true, toastDefinition: 'successSignOutDevice', data: '' }))
}
export function* onSuccessSignOutDevice() {
    yield takeLatest(UserActionTypes.SUCCESS_SIGN_OUT_DEVICE, successSignOutDevice)
}

function* failureSignOutDevice({ payload: data }) {
    yield put(startToastDisplay({ display: true, toastDefinition: 'failureSignOutDevice', data: data?.errorMessage[0]?.errorCode }))
}
export function* onFailureSignOutDevice() {
    yield takeLatest(UserActionTypes.FAILURE_SIGN_OUT_DEVICE, failureSignOutDevice)
}

export function* toastSagas() {
    yield all([
        call(onSuccessLedgerTopUpWithBankTransfer),
        call(onSuccessTransfer),
        call(onSuccessTransferToBank),
        call(onStartTopUpTradingDesks),
        call(onStartWithdrawFromTradingDesk),
        call(onSuccessExchangeTradingDesk),
        call(onFailureArchiveSupportConversations),
        call(onFailureTransactions),
        call(onFailureGetSupportConversations),
        call(onFailureReplySupportConversations),
        call(onFailureSupportConversationsDetails),
        call(onFailureGetFile),
        call(onSuccessArchiveSupportConversations),
        call(onSuccessReplySupportConversations),
        call(onFailureBatchPayments),
        call(onSuccessSignOutDevice),
        call(onFailureSignOutDevice),
    ])
}
